
import { Mixins, Component } from 'vue-property-decorator';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/course';
import { isExit } from '@/plugin/auth/auth';
import tButton from '@/components/Button/tButton.vue';
import BsMixin from '@/views/Home/mixins/bsMixin';
import tableMixin from './tableMixin';
import uModal from './compoents/upload/index.vue';
import cModal from './compoents/contract/index.vue';
import bModal from './compoents/bModal.vue';
import rModal from './compoents/cropper/index.vue';

@Component({
  components: {
    tButton,
    uModal,
    cModal,
    bModal,
    rModal,
  },
})
export default class AssetWrapper extends Mixins(BsMixin, tableMixin) {
  private arrs: Array<any> = [];

  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/course/chapter/resource:add',
    icon: 'plus',
    callback: this.handleAddResource,
    log: {
      name: '试听管理 - 新增',
      component: 'trial/manage/bModal',
    },
  }];

  private visible: any = {
    upload: false,
    contract: false,
    rescource: false,
    cropper: false,
  };

  private row: any = {};

  private questionVisible: boolean = false;

  private questionRow: any = {};

  /** 从有编辑权限的C++资源打开独立关联快照，不修改列表对象。 */
  handleChangeQuestion(row: any) {
    if (row.resourceType !== 14 || !isExit('/course/chapter/resource:update')) return;
    this.questionRow = { ...row };
    this.questionVisible = true;
  }

  /** 局部合并服务端关联摘要，其余字段与其他行保持当前值。 */
  questionSaved(result: any) {
    const rows = (this as any).cList;
    const index = rows.findIndex((row: any) => row.pid === result.pid);
    if (index < 0) return;
    this.$set(rows, index, {
      ...rows[index],
      ...result,
      linkedQuestionLabel: this.questionLabel({ ...rows[index], ...result }),
    });
  }

  private title: string = '添加资源';

  private uploadTitle: string = '附件上传';

  public $refs!: {
    rescource: Element,
  }

  mounted() {
    this.initBS(this.$refs.rescource);
  }

  /** 新建时清空上一条资源，避免误带题关联；无入参，无返回值。 */
  handleAddResource() {
    this.row = { stepPid: this.chapterId };
    this.title = '添加资源';
    this.visible.rescource = true;
  }

  /** C++ 上传作为原作品关联的可选补充，不修改题号关联。 */
  handleCppUpload() {
    this.visible.contract = false;
    this.uploadTitle = '上传 C++ 源码';
    this.visible.upload = true;
  }

  handleOperate(row: any) {
    this.uploadTitle = row.resourceType === 16 ? 'HTML包上传' : '附件上传';
    if ([14, 15].includes(row.resourceType)) this.uploadTitle = '上传 C++ 源码';
    if (row.resourceType === 3
    || row.resourceType === 4
    || row.resourceType === 5
    || row.resourceType === 6
    || row.resourceType === 13
    || row.resourceType === 16) {
      this.visible.upload = true;
      this.row.pid = row.pid;
      this.row.resourceType = row.resourceType;
    } else {
      this.visible.contract = true;
      this.row.pid = row.pid;
      this.row.resourceType = row.resourceType;
    }
  }

  /** 编辑资源并回显关联摘要；row 为所选行，返回 void。 */
  handleEdit(row: any) {
    this.visible.rescource = true;
    this.title = '修改资源';
    const {
      pid,
      stepPid,
      resourceType,
      resourceSeq,
      resourceTitle,
      resourceUser,
    } = row;
    this.row = {
      ojQuestionPid: row.ojQuestionPid == null ? null : String(row.ojQuestionPid),
      linkedQuestion: row.linkedQuestion,
      questionLinkStatus: row.questionLinkStatus,
      pid,
      stepPid,
      resourceType,
      resourceSeq,
      resourceTitle,
      resourceUser,
    };
  }

  refrsh() {
    this.getData(this.chapterId);
  }

  handleCellClick(row:any, column: any, event: any) {
    if (column.label === '缩略图标') {
      this.visible.cropper = true;
      this.row = row;
    }
  }
}
